

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {IShortUser} from "@/model/shortInterfaces";
  import {Prop} from "vue-property-decorator";
  import {IErrors} from "@/model/IErrors";
  import UserSearch from "@/components/user/widget/UserSearch.vue";
  import UserChip from "@/components/shared/chips/UserChip.vue";

  @Component({
    name: 'BoUserField',
    components: {
      UserChip,
      UserSearch,
    }
  })
  export default class BoUserField extends Vue {

    @Prop()
    protected label!: string;
    @Prop({default: () => {}})
    protected value!: IShortUser;
    @Prop()
    protected errorMessages!: IErrors;

    protected userSearchShowing: boolean = false;

    protected get hasValue(): boolean {
      return this.value && !!this.value.id;
    }

    onShowUserSearch() {
      this.userSearchShowing=true
    }
    onUserSearchBlur() {
      this.userSearchShowing = false;
    }
    onUserSelected(user: IShortUser) {
      this.userSearchShowing = false;
      this.$emit('input', user);
    }

  }

